var _circle, _circle2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#9AA1AB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 40,
    r: 16,
    fill: "#F5F6F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 58c-18 0-32 12-32 26v16h64V84c0-14-14-26-32-26z",
    fill: "#F5F6F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatar);
export default __webpack_public_path__ + "static/media/default-avatar.4bebd8046f5de0235cab76c7427eb5c1.svg";
export { ForwardRef as ReactComponent };